import { keyValueObject } from './utils';

export const getAnchorNewTab = function (url: string, text: string, style?: keyValueObject) {
    return (
        <a href={url} target="blank" style={style}>
            {text}
        </a>
    );
};

export const getComingSoonElement = function (style?: keyValueObject) {
    return (
        <span
            style={{
                fontSize: 14,
                fontWeight: 400,
                fontFamily: 'PoppinsRegular',
                margin: '4px 0',
                textDecoration: 'none',
                float: 'right',
                opacity: 0.5,
                ...style,
            }}
        >
            [coming soon]
        </span>
    );
};

export const getTrimmedStyle = function (maxLen: number): keyValueObject {
    return {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: `${maxLen}ch`,
    };
};
